import { useTheme, css } from "@emotion/react";
import useBreakpoints from "@util/breakpoints";
import { rem, em } from "@util/convertUnits";
import pageFooterNavData from "./pageFooterNav.data";
import PageFooterMobileAccordian from "./PageFooterMobileAccordian";

const root = window.location.origin || "";

const PageFooter = () => {
  const theme = useTheme();

  const bgGrayLight = css(`background-color: rgba(248, 248, 248, 0.9);`);
  const bgGray = css(`background-color: #ececec;`);
  const textHead = css(`font-family: ${theme.header.fontFamily};`);
  const bold = css(` font-weight: 500; `);

  const listStyle = useBreakpoints([theme.breakpoint.sm])({
    listStyle: "none",
    padding: 0,
    margin: 0,

    "li": {
      marginBottom: [0, em(24, 16)],
      // fontSize: em(16),
      lineHeight: em(18, 16),

      "> span": {
        padding: ["1.3rem 2.4rem 1.3rem", "0"],
      },

      "> ul": {
        padding: ["2.4rem 2.4rem 0.8rem", "0"],
        backgroundColor: ["#F4F4F4", "transparent"]
      },

      "li": {
        marginBottom: em(24, 16),
        // fontSize: em(16, 16), // resize to match, inherited from parent <li>
      },

      "li:last-child": {
        marginBottom: [em(16, 16), em(24, 16)],
      },

      "a": {
        display: "block",
        color: "rgba(0,0,0,0.7)",
        textDecoration: "none",

        "&:hover": {
          color: "rgba(0,0,0,0.7)",
          textDecoration: "underline",
        }
      }
    }
  });

  const listFirstCol = useBreakpoints([theme.breakpoint.sm])({
    "li": {

      "&:first-of-type": {
        marginBottom: ["1.8rem"],
      }
    },
  });

  const iconWrap = useBreakpoints([theme.breakpoint.sm, theme.breakpoint.ns])({
    maxWidth: ["initial", rem(600), rem(320)],
  });

  return (
    <div className={'footer'}>

      <div css={bgGrayLight}>
        <div className={'container'}>
          <div className={'row pt-5.5 pb-3 pb-sm-0'} >
            {pageFooterNavData.map((group, i) => {
              return (
                <div
                  key={`${group.groupHeader}${group.children[0].name}`}
                  className={'size-full size-sm-1of2 size-ns-1of3 size-lg-1of6 pb-0 pb-sm-2 px-0 px-sm-2'}
                >
                  <ul css={i === 0 ? [listStyle, listFirstCol] : [listStyle]}>
                    {
                      group.groupHeader
                        ? <PageFooterMobileAccordian group={group} listStyle={listStyle} />
                        : group.children.map((child) => (
                          <li key={`${child.name}${child.url}`}>
                            <a href={child.url}>{child.name}</a>
                          </li>
                        ))
                    }
                  </ul>
                </div>
              )
            })}
          </div>
        </div>
      </div>

      <div css={bgGray}>
        <div className={'container'}>
          <div className={'row row-alignMiddle py-3.5'}>

            <div className={'posRelative size-full size-ns-1of2 text-center text-ns-right push-ns-1of2 pb-3 pb-ns-0'} >
              <div className={'row mx-auto mr-ns-n2'} css={[iconWrap]}>
                <a target="_blank" rel="noreferrer" href="https://www.facebook.com/pages/LaCantina-Doors/167926889918291">
                  <img
                    src={"/images/social-icons/facebook.png"}
                    title={"Facebook"}
                    alt={"Facebook"}
                    loading="lazy"
                  />
                </a>
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/lacantina-doors">
                  <img
                    src={"/images/social-icons/linkedin.png"}
                    title={"LinkedIn"}
                    alt={"LinkedIn"}
                    loading="lazy"
                  />
                </a>
                <a target="_blank" rel="noreferrer" href="https://instagram.com/lacantinadoors/">
                  <img
                    src={"/images/social-icons/instagram.png"}
                    title={"Instagram"}
                    alt={"Instagram"}
                    loading="lazy"
                  />
                </a>
                <a target="_blank" rel="noreferrer" href="https://twitter.com/#!/lacantinadoors">
                  <img
                    src={"/images/social-icons/twitter-x.png"}
                    title={"Twitter"}
                    alt={"Twitter"}
                    loading="lazy"
                  />
                </a>
                <a target="_blank" rel="noreferrer" href="https://www.youtube.com/LaCantinaDoors1">
                  <img
                    src={"/images/social-icons/youtube.png"}
                    title={"YouTube"}
                    alt={"YouTube"}
                    loading="lazy"
                  />
                </a>
                <a target="_blank" rel="noreferrer" href="https://pinterest.com/lacantinadoors/">
                  <img
                    src={"/images/social-icons/pinterest.png"}
                    title={"Pinterest"}
                    alt={"Pinterest"}
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
            <div className={'posRelative size-full size-ns-1of2 pull-ns-1of2'}>
              <div className={'row'}>
                <div className={'size-full size-ns-fit text-center text-ns-left pb-3 pb-ns-0'} id={`footer-copyright`} css={[bold, textHead]}>
                  &copy; <strong>{new Date().getFullYear()} LaCantina Doors</strong>
                </div>
                <div className={'size-full size-ns-fit text-center text-ns-left'} css={[textHead]}>
                  <a href={root + '/terms-of-use'}>Terms of use</a> | <a href={root + '/sitemap'}>Site Map</a> | <a href={'https://www.jeld-wen.com/en-us/about-us/general-information/privacy-policy'}>Privacy Policy</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default PageFooter;
